import { AssignTradeMode } from '../../constants/assign-trade.constant';
import {
  OutboundPartnerIdType,
  TargetTradeOption,
} from '../../constants/job-post/job-post.enums';
import { Tradee } from './job.model';

export class AssignTradeOptions {
  static instance: AssignTradeOptions;

  mode: AssignTradeMode;
  secondaryJobTypeId: string;
  suburbId: string;
  jobId: string;
  propertyId: string;
  private _targetTardeOption: TargetTradeOption;
  public get targetTardeOption(): TargetTradeOption {
    return this._targetTardeOption ?? TargetTradeOption.WorkOrder;
  }
  public set targetTardeOption(value: TargetTradeOption) {
    this._targetTardeOption =
      value in TargetTradeOption ? value : TargetTradeOption.WorkOrder;
  }
  includeAllSuburbs: boolean;
  includePendingInvitationTrades: boolean;
  selectOnDemandTrades: boolean;
  searchText: string;
  currentPage: number;
  totalTradesCount: number;
  selectedTrades: Tradee[] = [];
  assignTrades: AssignTradeResponse[] = [];
  onDemandTrades: OnDemandTradesResponse[] | null;
  selectedTradeeMiniProfile: MiniProfile | null;
  initialPayment: number;
  externalTrade: ExternalTrade;
  ownerOverrideReason: string;
  quoteLimt: number;
  notifyOwner: boolean = false;
  tradesBeforeEdit: Tradee[] = [];
  targetTardeOptionBeforeEdit: TargetTradeOption;
  prevSecondaryJobTypeId: string;
  isSelectedOnRequestQuotesFromHipages: boolean;
  primaryJobTypeId: string;
  selectBNATrades: boolean;
  selectAllTrades: boolean;
  selectAgencyPreferredTrades: boolean;
  selectPMPreferredTrades: boolean;
  tabClick: boolean;
  isAllAgencyRegisteredTradeView: boolean;
  notifyTenantViaSMS: boolean = false;
  notifyTradeViaSMS: boolean =false;
  isAllEmailNotificationsDisabled: boolean =false;
  doNotNotifyTrade:boolean =false;
  notifyOwnerFutureJobs: boolean = false;
  private constructor() {
    this.includeAllSuburbs = false;
    this.includePendingInvitationTrades = false;
    this.searchText = '';
    this.currentPage = 0;
    this.totalTradesCount = 0;
    this.externalTrade = new ExternalTrade();
    this.quoteLimt = 0;
    this.jobId = '';
    this.selectBNATrades = false;
    this.selectAllTrades = true;
    this.selectAgencyPreferredTrades = false;
    this.selectPMPreferredTrades = false;
    this.tabClick = false;
    this.isAllAgencyRegisteredTradeView = false;
  }

  isJobIdMust() {
    return this.mode == AssignTradeMode.ApproveJob ? this.jobId : true;
  }

  canAssignTrade() {
    return (
      this.mode &&
      this.secondaryJobTypeId &&
      this.suburbId &&
      this.isJobIdMust()
    );
  }

  public setInitialTargetTradeOption() {
    if (this.targetTardeOption) return;

    this.targetTardeOption = TargetTradeOption.WorkOrder;
  }

  public static getInstance(): AssignTradeOptions {
    if (!AssignTradeOptions.instance)
      AssignTradeOptions.instance = new AssignTradeOptions();
    return AssignTradeOptions.instance;
  }

  public static distroyObj() {
    AssignTradeOptions.instance = undefined;
  }
}
export interface AssignTradeResponse {
  id: string;
  name: string;
  email: string;
  businessName: string;
  apprvedInsuranceAndLicense: boolean;
  branchPreferredTrade: boolean;
  pmPreferredTrade: boolean;
  totalRowCount: number;
  isSelected: boolean;
  selectedToShowProfile: boolean;
  isBranchTradee: boolean;
  isJobDeclined: boolean;
  primaryJobTypes: string;
  primaryJobTypesDisplay: string;
  isLiteTrade: boolean;
  activationStatus: number;  
  isAllEmailNotificationsDisabled: boolean;
  isHomeERTrade: boolean;
  isClosestTrade: boolean;
}

export interface MiniProfile {
  id: string;
  name: string;
  email: string;
  businessName: string;
  profileImageUrl: string;
  hourlyRate: number;
  calloutFee: number;
  vaccinated: boolean;
  completedJobs: number;
  openJobs: number;
  totatJobs: number;
  avarageRating: number;
  agencyPreferredTrade: boolean;
  pmPreferredTrade: boolean;
  apprvedInsuranceAndLicense: boolean;
  averageTimeToCompleteJob: string;
  pendingInviteTrade: boolean;
  isBranchTradee: boolean;
  isAllEmailNotificationsDisabled: boolean;  
  isHomeERTrade: boolean;
  isClosestTrade: boolean;
}

export interface OnDemandTradesResponse {
  id: string;
  name: string;
  email: string;
  businessName: string;
  markerPositions: google.maps.LatLngLiteral;
  latitude: number;
  longitude: number;
  isSelected: boolean;
}

export class ExternalTrade {
  companyEmail: string;
  companyName: string;
  attendingOwnerId? :string;
}

export class AssignTradeRequest {
  jobId: string;
  targetTradeeOption: TargetTradeOption;
  selectedTradees: string[];
  initialPayment: number;
  quoteLimit?: number;
  externalTrade: ExternalTrade;
  note: string;
  jobNote: string;
  isPrivateNote: boolean;
  isOwnerAttending: boolean;
  isHideTenantDetailsToOwner: boolean;
  notifyOwner: boolean;
  isOwnerApprovalRequested: boolean;
  outboundPartnerId: OutboundPartnerIdType;
  excludedNotifyParties: number[] = [];
  primaryJobTypeId: string;
  secondaryJobTypeId: string;
  notifyTenantViaSMS: boolean;
  notifyTradeViaSMS: boolean;
  doNotNotifyTrade:boolean;
  attendingOwnerId? :string;
  notifyOwnerFutureJobs: boolean;

  constructor(
    options: AssignTradeOptions,
    note?: string,
    isPrivateNote: boolean = false,
    isOwnerAttending: boolean = false,
    isHideTenantDetailsToOwner: boolean = false,
    isOwnerApprovalRequested: boolean = false
  ) {
    this.jobId = options.jobId;
    this.targetTradeeOption = options.selectOnDemandTrades
      ? TargetTradeOption.OnDemand
      : options.targetTardeOption;
    this.selectedTradees = options.selectedTrades.map((tradee) => {
      return tradee.id;
    });
    this.initialPayment = options.initialPayment;
    this.quoteLimit = options.quoteLimt;
    this.externalTrade = options.externalTrade;
    this.note = note;
    this.isPrivateNote = isPrivateNote;
    this.isOwnerAttending = isOwnerAttending;
    this.isHideTenantDetailsToOwner = isHideTenantDetailsToOwner;
    this.notifyOwner = options.notifyOwner;
    this.isOwnerApprovalRequested = isOwnerApprovalRequested;
    this.outboundPartnerId = this.getOutboundPartnerId(options);
    this.notifyTenantViaSMS = options.notifyTenantViaSMS;
    this.notifyTradeViaSMS = options.notifyTradeViaSMS;
    this.doNotNotifyTrade=options.doNotNotifyTrade;
    this.attendingOwnerId = options.externalTrade?.attendingOwnerId;
  }

  setExcludeNotifyParties(excludedNotifyParties: number[]) {
    this.excludedNotifyParties = excludedNotifyParties;
  }
  getOutboundPartnerId(options: AssignTradeOptions): OutboundPartnerIdType {
    if (options.isSelectedOnRequestQuotesFromHipages) {
      return OutboundPartnerIdType.HiPages;
    } 
    else if(options.assignTrades.some(x=> x.isHomeERTrade && x.isSelected)){
      return OutboundPartnerIdType.HomeEr;
    }
    else {
      return OutboundPartnerIdType.None;
    }
  }
  setServiceType(primaryJobTypeId: string, secondaryJobTypeId: string) {
    this.primaryJobTypeId = primaryJobTypeId;
    this.secondaryJobTypeId = secondaryJobTypeId;
  }
}
